import {
  formatDateRange,
  getDateRange,
} from '@modules/common/components/DateRangePicker/helpers';
import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { QuantifyQuery } from '@modules/quantify/store/types';
import { getDurationForCompareByPreviousTimePeriod } from '@modules/quantify/utils';

interface getPreviousTimePeriodDateRangeStringOptions {
  compareQuery: QuantifyQuery['compareQuery'];
  duration: DateTimeRange;
}

export const getPreviousTimePeriodDateRangeString = ({
  compareQuery,
  duration,
}: getPreviousTimePeriodDateRangeStringOptions): string => {
  const previousPeriodDuration = compareQuery?.previousPeriod
    ? getDurationForCompareByPreviousTimePeriod(duration, compareQuery)
    : null;

  const [from, to] = getDateRange(previousPeriodDuration);
  const previousPeriodDateRangeString =
    from && to ? formatDateRange(from, to) : '';

  return previousPeriodDateRangeString;
};
